import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=19a2e1a0"
import script from "./BrandPage.vue?vue&type=script&lang=js"
export * from "./BrandPage.vue?vue&type=script&lang=js"
import style0 from "./BrandPage.vue?vue&type=style&index=0&id=19a2e1a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports